import { render, staticRenderFns } from "./DevBpbjStandardQtInfo.vue?vue&type=template&id=2dcfb1e2&scoped=true&"
import script from "./DevBpbjStandardQtInfo.vue?vue&type=script&lang=js&"
export * from "./DevBpbjStandardQtInfo.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjStandardQtInfo.vue?vue&type=style&index=0&id=2dcfb1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfb1e2",
  null
  
)

export default component.exports